import * as React from 'react';
import Button from '@roo/roo/Button';
import { useHistory } from 'react-router';

const InvoiceLink: React.FC = () => {
    const history = useHistory();
    return (
        <Button
            className="invoice-link"
            onClick={() => {
                history.push('/invoice?type=apply');
            }}
            type="brand"
        >
            申请开票
        </Button>
    );
};
export default InvoiceLink;
